/* eslint-disable
    block-scoped-var,
    no-bitwise,
    no-use-before-define,
    no-var,
    vars-on-top,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('NavGraphDailyService', () => {
    const formatTs = (ts) => moment(ts).format('DD/MM/YY')

    const toDate = (dateString) => moment(dateString, 'YYYY-MM-DD').toDate()

    const colors = {}

    const stringToRGB = function (elem) {
        if (elem.url) {
            if (colors[elem.url]) {
                return colors[elem.url]
            }
            let i
            let hash = 0
            for (i = 0, end = elem.url.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                var asc
                var end
                hash = elem.url.charCodeAt(i) + ((hash << 5) - hash)
            }
            let c = '#'
            for (i = 0; i < 3; i++) {
                const value = (hash >> (i * 8)) & 0xFF
                c += (`00${value.toString(16)}`).substr(-2)
            }
            colors[elem.url] = c
            return c
        }
        return 'steelblue'
    }

    const display = function (selector, data, reloadWithDates) {
        const margin = { top: 30, right: 0, bottom: 40, left: 30 }
        const width = 1325 - margin.left - margin.right
        const height = 600 - margin.top - margin.bottom

        const div = d3.select('body').append('div')
        .attr('class', 'graph-tooltip')
        .style('opacity', 0)

        d3.selectAll(selector).select('svg').remove()

        const svg = d3.select(selector).append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

        const x = d3.scaleLinear().range([0, width])
        const y = d3.scaleLinear().range([height, 0])

        let tickValues = [moment(data[0] != null ? data[0].date : undefined, 'YYYY-MM-DD').add(-1, 'days').toDate().getTime()]
        const diffDates = moment(__guard__(data[data.length - 1], (x1) => x1.date), 'YYYY-MM-DD').diff(moment(data[0] != null ? data[0].date : undefined, 'YYYY-MM-DD').add(-1, 'days'), 'days')

        let i = 0
        const n = data.length
        let elem
        while (i < n) {
            elem = data[i]
            if ((i > 0) && (data[i - 1].date === elem.date)) {
                elem.yOffset = data[i - 1].height + data[i - 1].yOffset
            } else {
                elem.yOffset = 0
            }
            elem.height = elem.count
            tickValues.push(toDate(elem.date).getTime())
            i += 1
        }

        tickValues = _.uniq(tickValues)
        const barWidth = Math.max(1, Math.min(30, parseInt((width / diffDates), 10) - 1))

        x.domain([moment(data[0] != null ? data[0].date : undefined, 'YYYY-MM-DD').add(-1, 'days').toDate(), d3.timeDay.offset(toDate(__guard__(data[data.length - 1], (x2) => x2.date)), 1)])
        .rangeRound([0, width - margin.left - margin.right])
        y.domain([0, d3.max(data.map((d) => d.height + d.yOffset))])

        const tooltipNav = (el) => `${el.date}<br/>${el.count}${el.url ? (`<br/>${el.url}`) : ''}`



        const xAxis = d3.axisBottom(x)
        .tickValues(tickValues)
        .tickFormat(formatTs)

        const tooltipOn = function (tooltipFunc, d) {
            div.transition()
            .duration(200)
            .style('opacity', 0.9)
            return div.html(tooltipFunc(d))
            .style('left', `${d3.event.pageX + 20}px`)
            .style('top', `${d3.event.pageY - 28}px`)
        }

        const tooltipOff = (d) =>
            div.transition()
            .duration(500)
            .style('opacity', 0)


        svg.append('rect')
        .attr('class', 'bground')
        .attr('x', (d) => 0)
        .attr('width', (d) => width)
        .attr('y', (d) => 0)
        .attr('height', (d) => height)

        svg.selectAll('.bin')
        .data(data)
        .enter().append('rect')
        .attr('class', 'navigation')
        .attr('ry', 3)
        .attr('x', (d) => x(toDate(d.date)) - (barWidth / 2))
        .attr('width', (d) => barWidth)
        .attr('y', (d) => y(d.height + d.yOffset))
        .attr('height', (d) => height - y(d.height))
        .attr('fill', (d) => stringToRGB(d))
        .style('opacity', 0.7)
        .on('mouseover', tooltipOn.bind(null, tooltipNav))
        .on('mouseout', tooltipOff)

        svg.append('g')
        .attr('class', 'x axis')
        .attr('transform', `translate(0, ${height})`)
        .call(xAxis)

        svg.append('g')
        .attr('class', 'y axis')
        .call(d3.axisLeft(y))

        svg.selectAll('.bin')
        .data(data)
        .enter().append('text')
        .attr('x', (d) => x(toDate(d.date)) - 4)
        .attr('y', (d) => y(d.height + d.yOffset) + ((height - y(d.height)) / 2))
        .attr('dy', '.35em')
        .attr('fill', 'white')
        .text((d) => d.count)
        .on('mouseover', tooltipOn.bind(null, tooltipNav))
        .on('mouseout', tooltipOff)

        if (diffDates > 25) {
            svg.selectAll('.x text')
            .attr('transform', function (d) { return `translate(${(this.getBBox().height * -2) + 10},${this.getBBox().height})rotate(-45)` })
        }


        const pointStart = {
            x: 0,
            y: 0,
        }

        return svg.on('mousedown', function () {
            d3.selectAll('g.selected').classed('selected', false)
            const p = d3.mouse(this)
            pointStart.x = p[0]
            pointStart.y = p[1]
            return svg.append('rect')
            .attr('rx', 6)
            .attr('ry', 6)
            .attr('class', 'selection')
            .attr('x', p[0])
            .attr('y', p[1])
            .attr('width', 0)
            .attr('height', 0)
        }).on('mousemove', function () {
            const s = svg.select('rect.selection')

            if (!s.empty()) {
                const p = d3.mouse(this)
                const d = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                }

                if (p[0] > pointStart.x) {
                    d.x = pointStart.x
                    d.width = p[0] - pointStart.x
                } else {
                    d.x = p[0]
                    d.width = pointStart.x - p[0]
                }

                if (p[1] > pointStart.y) {
                    d.y = pointStart.y
                    d.height = p[1] - pointStart.y
                } else {
                    d.y = p[1]
                    d.height = pointStart.y - p[1]
                }

                Object.keys(d).forEach((k) => {
                    s.attr(k, d[k])
                })
                return s
            }
        }).on('mouseup', function () {
            const p = d3.mouse(this)

            const xStart = p[0] > pointStart.x ? pointStart.x : p[0]
            const xEnd = p[0] > pointStart.x ? p[0] : pointStart.x

            const dateStart = moment(parseInt(x.invert(xStart), 10)).toDate()
            const dateEnd = moment(parseInt(x.invert(xEnd), 10)).toDate()

            reloadWithDates(dateStart, dateEnd)

            svg.selectAll('rect.selection').remove()
            return tooltipOff()
        }).on('mouseout', () => tooltipOff())
    }



    return {
        display,
    }
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
